module.exports = __webpack_public_path__ + "static/media/igl2.cc0c349c.png";